import consumerApi from "api/services/consumer-api";
import consumerApiCa from "api/services/consumer-api-ca";
import { BrandsResponse } from "custom-types/Brand";
import { Coordinates } from "custom-types/Coordinates";
import logError from "utils/logError";

type Props = {
  coordinates?: Coordinates;
  countryCode: string;
  searchTerm?: string;
  skip?: number;
  sort?: "asc" | "desc";
  take?: number;
};

export const getBrands = async ({
  coordinates,
  countryCode,
  skip,
  sort,
  take,
  searchTerm,
}: Props): Promise<BrandsResponse> => {
  const api = countryCode === "CA" ? consumerApiCa : consumerApi;

  try {
    const { data } = await api.get<BrandsResponse>(`/api/brands/v2`, {
      params: {
        ...(coordinates && { lat: coordinates.lat, lon: coordinates.lon }),
        ...(searchTerm && { q: searchTerm }),
        ...(skip && { skip }),
        ...(sort && { "sort[][name]": sort }),
        ...(take && { take }),
      },
    });

    return data;
  } catch (e) {
    logError(e.message, {
      functionName: "getBrands",
      service: "consumer",
      statusCode: e.statusCode,
    });

    return { data: [], metadata: { totalCount: 0 } };
  }
};
